import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import { CENTRIFUGE_CONNECTION } from './actions';
import { CENTRIFUGE_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

const initialState = {
  centrifugeStatus: 2,
};

const reducer = handleActions({
  [CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION + FAILED]: state => ({
    ...state,
    centrifugeStatus: 2,
  }),
  [CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION]: state => ({
    ...state,
    centrifugeStatus: 1,
  }),
  [CENTRIFUGE_MODULE + CENTRIFUGE_CONNECTION + SUCCESSFUL]: state => ({
    ...state,
    centrifugeStatus: 0,
  }),
}, initialState);

export default reducer;

export const getCENTRIFUGEData = createSelector(
  [state => state[CENTRIFUGE_MODULE]],
  state => {
    const {
      centrifugeStatus,
    } = state;
    return {
      centrifugeStatus,
    };
  },
);
